const baseUrl = {
  cpo: process.env.REACT_APP_API_NETWORKS_URL,
  emsp: process.env.REACT_APP_API_MOBILITY_URL,
  devices: process.env.REACT_APP_API_DEVICES_URL,
  subscription: process.env.REACT_APP_API_SUBSCRIPTIONS_URL,
};

const config = {
  cpo: {
    authApiUrl: `${baseUrl.cpo}auth/`,
    accountApiUrl: `${baseUrl.subscription}accounts/`,
    tariffApiUrl: `${baseUrl.cpo}tariffs/`,
    commonApiUrl: `${baseUrl.cpo}common/`,
    ocppApiUrl: `${baseUrl.cpo}ocpp-service/`,
    sessionsApiUrl: `${baseUrl.cpo}sessions/`,
    communicationApiUrl: `${baseUrl.cpo}communication/`,
    notificationApiUrl: `${baseUrl.cpo}notifications/`,
    reportApiUrl: `${baseUrl.cpo}reporting/`,
    transactionApiUrl: `${baseUrl.cpo}transactions/`,
    emspApiUrl: `${baseUrl.cpo}emsp/`,
  },
  emsp: {
    authApiUrl: `${baseUrl.emsp}auth/`,
    emspApiUrl: `${baseUrl.emsp}emsp/`,
    sessionsApiUrl: `${baseUrl.emsp}sessions/`,
    DriversApiUrl: `${baseUrl.emsp}drivers/`,
    communicationApiUrl: `${baseUrl.emsp}communication/`,
    notificationApiUrl: `${baseUrl.emsp}notifications/`,
    transactionApiUrl: `${baseUrl.emsp}transactions/`,
    invoiceApiUrl: `${baseUrl.emsp}fcg/`,
  },
  devices: {
    authApiUrl: `${baseUrl.devices}auth/`,
    ChargersApiUrl: `${baseUrl.devices}device/`,
  },
  subscription: {
    authApiUrl: `${baseUrl.subscription}auth/`,
    accountApiUrl: `${baseUrl.subscription}accounts/`,
  },

  ocpiApiUrl: `${process.env.REACT_APP_API_OCPI_URL}ocpi/`,
  authApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}auth/`,
  tariffApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}tariffs/`,
  commonApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}common/`,
  ocppApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}ocpp-service/`,
  ocppOnlyApiUrl: `${baseUrl.cpo}ocpp/`,
  sessionsApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}sessions/`,
  communicationApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}communication/`,
  notificationApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}notifications/`,
  reportApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}reporting/`,
  transactionApiUrl: `${process.env.REACT_APP_API_NETWORKS_URL}transactions/`,
  // Mobility API

  // another
  websocketUrl: process.env.REACT_APP_SOCKET_SERVER_URL || '',
  domain: process.env.REACT_APP_DOMAIN || '',
  appUrl: process.env.REACT_APP_URL,
  qrCodeUrl: process.env.REACT_APP_QR_CODE_URL || '',
  internalApiKey: process.env.REACT_APP_INTERNAL_API_KEY || '',
  roamingJwtSecret: process.env.ROAMING_JWT_SECRET || '',
};

export default config;
